// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__Z-dMS","Backdrop":"Modal_Backdrop__1U2hX"};